export default __webpack_public_path__ + "static/banner-5-things-you-should-look-for-in-a-builder-c52d8dafd4b919d782d35666ffb8eb48.webp";